import {
  PARTNER_MATERIAL_LOCALES,
  PARTNER_MATERIAL_NEW_DAYS,
  pickPartnerMaterialLocale,
  type PartnerMaterialCategory,
  type PartnerMaterialLocale,
  type PartnerMaterialText
} from '@bliks-io/contracts';

/** Full keys, not templates: the translation check cannot resolve a template. */
export const PARTNER_MATERIAL_CATEGORY_KEYS: Record<PartnerMaterialCategory, string> = {
  salesDocuments: 'partner.infoHub.categories.salesDocuments',
  presentations: 'partner.infoHub.categories.presentations',
  caseStudies: 'partner.infoHub.categories.caseStudies',
  productInfo: 'partner.infoHub.categories.productInfo'
};

/** Language names in their own language, as a language switcher shows them. */
export const PARTNER_MATERIAL_LOCALE_NAMES: Record<PartnerMaterialLocale, string> = {
  de: 'Deutsch',
  en: 'English',
  fr: 'Français',
  hu: 'Magyar'
};

export function toPartnerMaterialLocale(language: string): PartnerMaterialLocale {
  const base = language.slice(0, 2);
  return base === 'de' || base === 'fr' || base === 'hu' ? base : 'en';
}

/** The text in the wanted language, else in the fallback order (German always exists). */
export function pickPartnerMaterialText(
  text: Partial<PartnerMaterialText> | undefined,
  locale: PartnerMaterialLocale
): string {
  const filled = PARTNER_MATERIAL_LOCALES.filter((value) => text?.[value]?.trim());
  const picked = pickPartnerMaterialLocale(filled, locale);
  return picked ? (text?.[picked]?.trim() ?? '') : '';
}

/** The language a download serves: the wanted one, else the fallback order. */
export function downloadLocaleFor(
  languages: PartnerMaterialLocale[],
  wanted: PartnerMaterialLocale
): PartnerMaterialLocale {
  return pickPartnerMaterialLocale(languages, wanted) ?? wanted;
}

const DAY_MS = 24 * 60 * 60 * 1000;

/** Whether partners should see the material flagged as new. */
export function isRecentlyChanged(changedAt: string, now = Date.now()): boolean {
  return now - new Date(changedAt).getTime() < PARTNER_MATERIAL_NEW_DAYS * DAY_MS;
}
